module.exports = __webpack_public_path__ + "h5/img/product.90f8a7cd.png";